export const SATELLITES = [
  { id: 25544, name: "ISS", color: "#38bdf8" },
  { id: 20580, name: "Hubble Space Telescope", color: "#f59e0b" },
  { id: 33591, name: "NOAA-19", color: "#34d399" },
];

export default SATELLITES;
